import { resolveMemberMediaUrl } from '@formosa/shared/utils/mediaUrl';
import { travelMemberProductDisplayName } from '../member-identity/memberIdentityPresentation';

function snowflakeId(value) {
  if (value == null || value === '') return null;
  const id = String(value);
  return /^[1-9]\d*$/.test(id) ? id : null;
}

export function normalizeConnectionItem(value) {
  const memberId = snowflakeId(value?.memberId);
  if (!memberId) return null;
  return {
    memberId,
    displayName: travelMemberProductDisplayName({
      displayName: value?.displayName,
      username: value?.username,
      nickname: value?.nickname,
    }),
    avatarUrl: resolveMemberMediaUrl(value?.avatarUrl),
    followedSince: value?.followedSince == null ? null : String(value.followedSince),
  };
}

export function normalizeConnectionPage(payload) {
  const items = Array.isArray(payload?.items)
    ? payload.items.map(normalizeConnectionItem).filter(Boolean)
    : [];
  const nextCursorFollowId = snowflakeId(payload?.nextCursorFollowId);
  return {
    items,
    nextCursorFollowId,
    hasMore: nextCursorFollowId != null,
  };
}

export function creatorPath(memberId) {
  const id = snowflakeId(memberId);
  return id ? `/social/creators/${id}` : null;
}

export function followersPath(memberId) {
  const id = snowflakeId(memberId);
  return id ? `/social/creators/${id}/followers` : null;
}

export function followingPeoplePath(memberId) {
  const id = snowflakeId(memberId);
  return id ? `/social/creators/${id}/following` : null;
}

/**
 * Presence-aware profile PUT body. Never send omitted fields as null.
 */
export function buildProfileUpdatePayload({
  nicknameDirty = false,
  nickname = '',
  avatarDirty = false,
  avatarObjectKey = null,
  avatarCleared = false,
} = {}) {
  const body = {};
  if (nicknameDirty) {
    const trimmed = nickname == null ? '' : String(nickname).trim();
    body.nickname = trimmed === '' ? null : trimmed.slice(0, 50);
  }
  if (avatarDirty) {
    body.avatar = avatarCleared ? null : (avatarObjectKey == null ? null : String(avatarObjectKey));
  }
  return body;
}
